import { StepStatus } from '@features/lead-management/constants';

import { Step } from './types';

export const getStepStatus = (
  step: Step | undefined,
  index: number,
  currentStepIndex: number
): StepStatus => {
  if (!step) return StepStatus.PENDING;

  if (step.status) {
    switch (step.status) {
      case StepStatus.COMPLETED:
        return StepStatus.COMPLETED;
      case StepStatus.CURRENT:
        return StepStatus.CURRENT;
      case StepStatus.PENDING:
        return StepStatus.PENDING;
      default:
        return StepStatus.PENDING;
    }
  }

  if (index < currentStepIndex) return StepStatus.COMPLETED;
  if (index === currentStepIndex) return StepStatus.CURRENT;
  return StepStatus.PENDING;
};

export const getStepStatusLabel = (step: Step | undefined): string => {
  if (!step) return '';
  return step.actualStatus || step.label;
};
